import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { SkillLibraryEntry } from '../types';

export default function useShareTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (skillId: string) => {
      const { data } = await api.post<SkillLibraryEntry>(`/tenant/custom-skills/${skillId}/share`);
      return data;
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] }),
        queryClient.invalidateQueries({ queryKey: ['skill-library'] }),
      ]);
    },
  });
}
